import React, { useEffect, useRef } from 'react';
import { compose } from 'recompose';

import { ControlPanel } from './components/ControlPanel';
import { AllCategory } from './components/GameCategory/components/AllCategory';

import { GameCategory } from 'js/app/components/main/Games/components/GameCategory';
import { Skeleton } from 'js/app/components/main/Skeleton';
import { withPortlet } from 'js/components/system/Portlet';

import {
    usePggCategory
} from 'js/app/components/main/Games/components/GameCategory/components/GameList/hooks/usePggCategory';
import { GAME_EVENTS } from 'js/app/components/main/Games/constants';
import { useGameComponentConfig } from 'js/app/components/main/Games/hooks/useGameComponentConfig';
import { useGameEventDispatch } from 'js/app/components/main/Games/hooks/useGameEventDispatch';
import { useIsAllCategories } from 'js/app/components/main/Games/hooks/useIsAllCategories';
import { useSetGamesConfig } from 'js/app/components/main/Games/hooks/useSetGamesConfig';
import { setFeedAction, setGameComponentRef } from 'js/app/components/main/Games/store/actions';
import { useFutureAnthemsList } from 'js/app/hooks/user/hooks/useFutureAnthemsList';

import { useCheckEmptyFeed } from './hooks/useCheckEmptyFeed';
import { useSetGapTile } from './hooks/useSetGapTile';
import { useGamesDispatch, useGamesSelector, withGamesProvider } from './store/context';

import style from './Games.scss';

const GamesBare = ({ gameComponentRef }) => {
    const dispatch = useGamesDispatch();
    const isAllCategories = useIsAllCategories();
    const gameEventDispatch = useGameEventDispatch();
    const { activeCategory } = useGamesSelector();

    useSetGapTile();

    useEffect(() => {
        dispatch(setGameComponentRef(gameComponentRef));

        gameEventDispatch({ name: GAME_EVENTS.GAME_PORTLET_DISPLAY });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {isAllCategories
                ? <AllCategory />
                : <GameCategory category={activeCategory} />
            }
        </>
    );
};

const GamesWithSkeleton = ({ feed }) => {
    const gameComponentRef = useRef();
    const dispatch = useGamesDispatch();
    const { enableListOfCategories, enableCtaButton } = useGameComponentConfig();
    const { activeCategory, isEmptyFeed } = useGamesSelector();

    useEffect(() => {
        if (feed) {
            dispatch(setFeedAction({
                hub2FeedName: feed,
                hub2ViewMode: 'inline'
            }));
        }
    }, [dispatch, feed]);

    usePggCategory();
    useSetGamesConfig(feed);
    useCheckEmptyFeed();
    useFutureAnthemsList();

    if (isEmptyFeed) {
        return null;
    }

    return (
        <div className={style.gameContainer} ref={gameComponentRef}>
            {(enableListOfCategories || enableCtaButton) && (
                <ControlPanel />
            )}

            {activeCategory.name
                ? <GamesBare gameComponentRef={gameComponentRef} />
                : <Skeleton />
            }
        </div>
    );
};

export const Games = compose(
    withPortlet({
        name: 'BuzzGames'
    }),
    withGamesProvider
)(GamesWithSkeleton);

export default Games;
